import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';

const AdminRoute = ({ children }) => {
  const { user, loading, isAdmin } = useAuth();
  const location = useLocation();

  // 如果正在加载，显示加载状态
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div>
          <p className="mt-4 text-gray-600">正在验证身份...</p>
        </div>
      </div>
    );
  }

  // 如果用户未登录，重定向到登录页面
  if (!user) {
    return <Navigate to="/admin/login" state={{ from: location }} replace />;
  }

  // 如果用户已登录但不是管理员，显示权限不足页面
  if (!isAdmin()) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="max-w-md w-full bg-white shadow-lg rounded-lg p-8 text-center">
          <div className="mb-6">
            <FontAwesomeIcon 
              icon={faExclamationTriangle} 
              className="h-16 w-16 text-red-500 mx-auto" 
            />
          </div>
          
          <h1 className="text-2xl font-bold text-gray-900 mb-4">
            权限不足
          </h1>
          
          <p className="text-gray-600 mb-6">
            抱歉，您没有权限访问此页面。此页面仅限管理员访问。
          </p>
          
          <div className="space-y-3">
            <button
              onClick={() => window.history.back()}
              className="w-full px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
            >
              返回上一页
            </button>
            
            <button
              onClick={() => window.location.href = '/admin/dashboard'}
              className="w-full px-4 py-2 border border-gray-300 text-gray-700 rounded-md hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
            >
              返回仪表板
            </button>
          </div>
          
          <div className="mt-6 pt-6 border-t border-gray-200">
            <p className="text-sm text-gray-500">
              当前用户：{user.username} ({user.role})
            </p>
          </div>
        </div>
      </div>
    );
  }

  // 如果用户是管理员，渲染子组件
  return children;
};

export default AdminRoute;